<ng-template>
    <div class="DsContextMenu u-spacing-sm-pv">
        <ng-content></ng-content>
    </div>
</ng-template>
